import Store from 'redux/store';
import { cloudloyalty } from '../clients';

import {FETCH_ORDER_DETAILS, FETCH_ORDER_DETAILS_SUCCESS, FETCH_ORDER_DETAILS_FAIL } from 'redux/Reducers/Orders/OrderDetails';

export const FetchOrderDetais = async (User, finallyCallback = () => {}, { orderId, offset, limit }) => {
    Store.dispatch({ type: FETCH_ORDER_DETAILS });
    cloudloyalty(User).get(`/v1/purchases/me/orders?orderId=${orderId}&offset=${offset}&limit=${limit}`)
    .then(({data: {orders, limit, offset, total }}) => {
        Store.dispatch({
            type: FETCH_ORDER_DETAILS_SUCCESS,
            payload: {
                orders,
                limit,
                offset,
                total,
            },
        });
    })
    .catch((e) => {
        Store.dispatch({
            type: FETCH_ORDER_DETAILS_FAIL,
            payload: {
                error: e
            }
        });
    })
    .finally(() => {
        finallyCallback();
    });
};
